var React = require('react');

function Preset2 (props) {
    return React.createElement("svg",props,React.createElement("g",{"style":{"mixBlendMode":"multiply"}},React.createElement("path",{"d":"M101.6 14C94.2836 16.7438 4.35569 46.8181 14.8508 63.1438C20.0145 71.1762 41.972 70.4607 49.0378 70.8359C101.644 73.6291 154.409 70.9581 207.046 73.9341C218.589 74.5867 321.067 80.7354 280.868 111.006C241.571 140.597 180.89 146.985 149.248 186.537C130.631 209.809 166.398 210.857 180.871 211.644C218.272 213.676 255.883 210.601 293.261 209.4C302.269 209.111 324.801 208.439 336.102 208.439C345.096 208.439 341.046 209.818 335.781 212.712C310.173 226.786 96.448 299.532 118.907 333.221","strokeWidth":"27.8838","strokeLinecap":"round","strokeLinejoin":"round"})));
}

Preset2.defaultProps = {"width":"350","height":"348","viewBox":"0 0 350 348","fill":"none"};

module.exports = Preset2;

Preset2.default = Preset2;
